import Icon from '@mui/material/Icon'
import Typography from '@mui/material/Typography'
import React from 'react'

import ExternalLink from '@/app/component/atom/external-link'

export const AI_INSIDE_SUPPORT_URL = 'https://www.engagespark.com/support/ai-inside/'

type Props = {
  text: string
}

const AiUsageHelper: React.FC<Props> = ({ text }) => (
  <Typography color="textSecondary" component="div" display="flex" mb={1} variant="caption">
    <div style={{ display: 'flex', alignItems: 'center', marginRight: 4 }}>
      <Icon style={{ fontSize: '20px' }}>assistant</Icon>&nbsp;{text}
    </div>
    <ExternalLink href={AI_INSIDE_SUPPORT_URL} sx={{ display: 'flex', alignItems: 'center' }}>
      Learn more
    </ExternalLink>
  </Typography>
)

export default AiUsageHelper
